import * as React from 'react'
import { Route } from 'react-router'
import { Switch } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import Collapse from 'src/components/Collapse'
import Footer from 'src/components/Footer'
import Header from 'src/components/Header'
import Login from 'src/components/Login'
import RouteFallback from 'src/components/RouteFallback'

import { HomeConfig } from '../../routes'
import RouteWithSubRoutes from '../../utils/route'
import NavConfig from './../../conf/collapse';
import styles from './index.scss';

const logo = require('./assets/icon-logo.png');
const close = require('./assets/icon-close.png');

const initialState = {
  showNav: false,
  showLogin: false,
  appLink: 'https://apps.apple.com/cn/app/%E9%A3%9E%E6%B4%9B%E5%8D%B0/id1481547951',
  showFooter: false,
  closeDownloadBar: false
}
type IState = Readonly<typeof initialState>
interface IWrapProps {
  history: any,
  queryStore: any,
  location: any,
  indexStore: any
  // props: any
}


@inject('indexStore')
@observer
class HomeLayout extends React.Component<IWrapProps, IState> {
  public readonly state = initialState
  public async componentDidMount() {
    document.addEventListener('scroll', this.closeLogin)
    this.closeFooter()
    this.checkSystem()
    // await this.props.indexStore.getApk()

  }
  public closeFooter = () => {
    this.setState({
      showFooter: this.props.history.location.pathname.includes('/check')
    })
  }
  public componentWillUnmount() {
    document.removeEventListener('scroll', this.closeLogin)
  }
  public closeLogin = () => {
    this.setState({
      showLogin: false
    })
  }
  public toggleLogin = () => {
    this.setState({
      showLogin: !this.state.showLogin,
      showNav: false
    })
  }
  public toggleNav = (flag?: boolean) => {
    this.setState({
      showNav: flag !== undefined ? flag : !this.state.showNav,
      showLogin: false
    })
  }
  public closeDownloadBar = () => {
    this.setState({
      closeDownloadBar: true
    });
  }
  public checkSystem = () => {
    const u = window.navigator.userAgent;
    // const app = window.navigator.appVersion;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAndroid) {
      this.setState({
        appLink: 'v1/app/getApk'
      });
    } else if (isIOS) {
      this.setState({
        appLink: 'https://apps.apple.com/cn/app/%E9%A3%9E%E6%B4%9B%E5%8D%B0/id1481547951'
      });
    }
  }
  public async download() {
    const request = {
      method: 'get',
      headers: {
        'Content-Type': 'application/json;application/vnd.android;charset=UTF-8'
      }
      // responseType: 'blob'
    }
    const response = await fetch('/v1/app/getApk', request);
    // const filename = response.headers.get('content-disposition').split(';')[1].split('=')[1];
    const blob = await response.blob();
    const link = document.createElement('a')
    link.download = 'filoink.apk';
    link.style.display = 'none'
    link.href = URL.createObjectURL(blob)
    document.body.appendChild(link)
    link.click()
    URL.revokeObjectURL(link.href)
    document.body.removeChild(link)
  }
  public render() {
    return (
      <div>
        <Header
          show={this.state.showNav}
          handleShowNav={this.toggleNav}
          handleShowLogin={this.toggleLogin}
          history={this.props.history}
        />
        <Login
          handleShowLogin={this.toggleLogin}
          show={this.state.showLogin}
          history={this.props.history}
        />
        <Collapse
          height="0.8"
          data={NavConfig}
          show={this.state.showNav}
          handleShowNav={this.toggleNav}
          history={this.props.history}
        />
        <Switch>
          {HomeConfig.map((route: any, index: number) => {
            return <RouteWithSubRoutes key={index} {...route} />
          })}
          <Route component={RouteFallback} />
        </Switch>
        {!this.state.showFooter && <Footer />}
        <div className={styles.downloadBar} style={{ display: this.state.closeDownloadBar ? 'none' : '' }}>
          <div>
            <img src={close} alt="" className={styles.closeImg} onClick={() => { this.closeDownloadBar(); }} />
            <img src={logo} alt="" className={styles.logoImg} />
            <p>
              <span className={styles.downloadTitle}>下载飞洛印APP</span>
              <span className={styles.downloadLabel}>一站式可信存取证服务移动平台</span>
            </p>
            <a href={this.state.appLink} rel="noopener noreferrer">立即下载</a>
            {/* <a href="/v1/app/getApk" rel="noopener noreferrer">立即下载</a> */}
            {/* <a onClick={this.download}>立即下载</a> */}
          </div>
        </div>
      </div>
    )
  }
}

export default HomeLayout



// WEBPACK FOOTER //
// ./src/layouts/HomeLayout/index.tsx